import { DashEligibilityCheckOutcome } from "@mirage/analytics/events/enums/dash_eligibility_check_outcome";
import { RedirectVariant } from "./types";

export const redirectVariantToDashEligibilityCheckOutcome = (
  variant: RedirectVariant,
): DashEligibilityCheckOutcome => {
  switch (variant) {
    case RedirectVariant.CountryBlock:
      return "blocked_user_country";
    case RedirectVariant.GenericBlock:
      return "blocked_user";
    case RedirectVariant.PendingInviteBlock:
      return "have_pending_team_invite";
    case RedirectVariant.DfbOnboarding:
      return "requires_dfb_onboarding";
    case RedirectVariant.UnverifiedEmail:
      return "unverified_email";
    case RedirectVariant.NoLicenseBlock:
      return "team_user_without_addon";
    case RedirectVariant.SuspendedTrialSubscription:
      return "suspended_trial_subscription";
    case RedirectVariant.SuspendedPaidSubscription:
      return "suspended_paid_subscription";
    default:
      return "blocked_user";
  }
};
